import { DenovoIcon, Pressable, Typography } from "@repo/design-system";

interface ICheckboxRowProps {
  label: string;
  isSelected: boolean;
  onPress: () => void;
}

export function CheckboxRow({ label, isSelected, onPress }: ICheckboxRowProps) {
  return (
    <Pressable
      onPress={onPress}
      className="flex cursor-pointer items-center gap-2.5 rounded-lg px-2 py-2 transition-colors hover:bg-backgroundSecondary">
      <div
        className={`flex h-4 w-4 flex-shrink-0 items-center justify-center rounded border transition-colors ${
          isSelected
            ? "border-borderBrand bg-backgroundBrand"
            : "border-borderSecondary bg-backgroundPrimary"
        }`}>
        {isSelected && (
          <DenovoIcon
            icon="check-bold"
            width={10}
            height={10}
            className="text-n0"
          />
        )}
      </div>
      <Typography variant="paragraph-m-medium" className="text-contentPrimary">
        {label}
      </Typography>
    </Pressable>
  );
}
